
import { useState } from "react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { useTranslations } from "@/hooks/useTranslations";

export const NotificationSettings = () => {
  const { t } = useTranslations("settings");
  const [settings, setSettings] = useState({
    email: true,
    push: true,
    schedule: true,
    marketing: false,
  });

  const handleSave = () => {
    // TODO: Implementar integração com backend
    toast.success("Preferências de notificações atualizadas");
  };

  return (
    <Card className="rounded-xl overflow-hidden">
      <CardHeader className="bg-gray-50 dark:bg-gray-900 rounded-t-xl">
        <CardTitle>{t("notifications.title")}</CardTitle>
        <CardDescription>
          {t("notifications.description")}
        </CardDescription>
      </CardHeader>
      <CardContent className="bg-gray-50 dark:bg-gray-900 rounded-b-xl">
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <Label htmlFor="email" className="flex flex-col">
              <span>{t("notifications.email")}</span>
              <span className="text-sm text-muted-foreground">
                {t("notifications.emailDescription")}
              </span>
            </Label>
            <Switch
              id="email"
              checked={settings.email}
              onCheckedChange={(checked) => setSettings(prev => ({ ...prev, email: checked }))}
            />
          </div>

          <div className="flex items-center justify-between">
            <Label htmlFor="push" className="flex flex-col">
              <span>{t("notifications.push")}</span>
              <span className="text-sm text-muted-foreground">
                {t("notifications.pushDescription")}
              </span>
            </Label>
            <Switch
              id="push"
              checked={settings.push}
              onCheckedChange={(checked) => setSettings(prev => ({ ...prev, push: checked }))}
            />
          </div>

          <div className="flex items-center justify-between">
            <Label htmlFor="schedule" className="flex flex-col">
              <span>{t("notifications.schedule")}</span>
              <span className="text-sm text-muted-foreground">
                {t("notifications.scheduleDescription")}
              </span>
            </Label>
            <Switch
              id="schedule"
              checked={settings.schedule}
              onCheckedChange={(checked) => setSettings(prev => ({ ...prev, schedule: checked }))}
            />
          </div>

          <div className="flex items-center justify-between">
            <Label htmlFor="marketing" className="flex flex-col">
              <span>{t("notifications.marketing")}</span>
              <span className="text-sm text-muted-foreground">
                {t("notifications.marketingDescription")}
              </span>
            </Label>
            <Switch
              id="marketing"
              checked={settings.marketing}
              onCheckedChange={(checked) => setSettings(prev => ({ ...prev, marketing: checked }))}
            />
          </div>

          <Button onClick={handleSave} className="rounded-xl">{t("notifications.saveButton")}</Button>
        </div>
      </CardContent>
    </Card>
  );
};
